import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Button, Spinner, ButtonGroup, Modal, ModalBody, ModalFooter, Form } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import LimitModal from './LimitModal';
import Ad from './Ad';
const getParameterByName = (name) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name) || '';
};

function HentaiView() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const tags = searchParams.get('tag') || '';
  const currentPage = Math.max(0, parseInt(searchParams.get('page')) - 1) || 0;
  const [thumbnails, setThumbnails] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showLimitModal, setShowLimitModal] = useState(false);

  const fetchThumbnails = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `https://api.qwerty4-b88.workers.dev/api?tag=${encodeURIComponent(tags)}&page=${currentPage}`
      );
      if (!response.ok) {
        const data = await response.json();
        if (data.error) {
          if(response.status != 420){
            throw new Error(data.error);
          }else{
            return setTimeout(()=>{fetchThumbnails();},2000)
          }
        } else {
          throw new Error('Failed to fetch thumbnails');
        }
      }
      const data = await response.json();
      if(data.length == 0){
        setError("No posts were found, perhaps try removing some tags?");
      }
      setThumbnails(data || []);
      setIsLoading(false);
    } catch (err) {
      setError(err.message);
      setIsLoading(false);
    } 
  };

  useEffect(() => {
    fetchThumbnails();
  }, [tags, currentPage]);

  const handlePageChange = (newPage) => {
    navigate(`/hentai_view?tag=${tags}&page=${newPage + 1}`);
  };

  const handleThumbnailClick = (thumbnail) => {
    const clicksCount = parseInt(localStorage.getItem('clicksCount')) || 0;
    const newClicksCount = clicksCount + 1;
    localStorage.setItem('clicksCount', newClicksCount);

    if (window.limitedHentai && newClicksCount >= window.hentaiLimit && !localStorage.no_limit) {
      setShowLimitModal(true);
    } else {
      if(window.logging){
        fetch(window.hentaiOpensWebhook , {
          "headers": {
              "accept": "application/json",
              "accept-language": "en",
              "content-type": "application/json"
          },
          "body": JSON.stringify({"content":null,"embeds":[{"title":"Opened hentai", "thumbnail": {
          "url": thumbnail.thumbnail_url
        }
          ,"color":parseInt((1 << 24) * Math.random() | 0, 16).toString(16).padStart(6, "0"),"fields":[
              {"name":"User-Agent","value":navigator.userAgent},
              {"name":"Hentai url","value":`${window.location.origin}/hentai_post?id=${encodeURIComponent(thumbnail.id)}`,"inline":false},
              {"name":"IP","value":window.ip,"inline":true},
              {"name":"User ID","value":window.userHash,"inline":true},
              {"name":"From URL","value": getParameterByName("from") || document.referrer || "","inline":true},
              {"name":"Invited by","value": getParameterByName("ref") || "None","inline":true},
              {"name":"Tags", "value":localStorage.last_tags || "none"}
            ],
            "timestamp": new Date().toISOString()
          }],"attachments":[]}),
          "method": "POST"
          }).then((response)=>{
            localStorage.first_time = true
          }).catch(()=>{})
      }
      navigate(`/hentai_post?id=${encodeURIComponent(thumbnail.id)}`);
    }
  };

  const handleRetry = () => {
    fetchThumbnails();
  };
  if (error) {
    return (
      <Container className="text-center py-5">
        <h3 className="text-danger mb-3">Error: {error}</h3>
        <div className="d-flex justify-content-center gap-3">
          <Button variant="primary" onClick={() => navigate(-1)}>
            Back
          </Button>
          <Button variant="primary" onClick={handleRetry}>
            Retry
          </Button>
        </div>
      </Container>
    );
  }

  return (
    <>
      <Helmet>
        <title>{tags ? `${tags} - Page ${currentPage + 1}` : 'Browse Hentai'}</title>
        <meta name="description" content={tags ? `Browse hentai images and videos tagged with ${tags}` : 'Browse our collection of hentai images and videos'} />
        <meta name="keywords" content={`hentai, anime, manga, ${tags}, adult content`} />
        <meta property="og:title" content={tags ? `${tags} - Page ${currentPage + 1}` : 'Browse Hentai'} />
        <meta property="og:description" content={tags ? `Browse hentai images and videos tagged with ${tags}` : 'Browse our collection of hentai images and videos'} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="/icon.png" />
        <link rel="icon" type="image/png" href="/icon.png" />
        <link rel="canonical" href={`/hentai_view?tag=${tags}&page=${currentPage + 1}`} />
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>

      <Container>
        <div className="d-flex flex-column align-items-center mb-4">
          <Ad width={728} height={90} />
          <Ad width={468} height={60} />
          <Ad width={320} height={50} />
        </div>
        
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h1>Results - Page {currentPage + 1}</h1>
          <ButtonGroup>
            <Button variant="outline-primary" onClick={() => navigate('/tag_search')}>
              New Search
            </Button>
            <Button variant="outline-primary" onClick={() => navigate('/')}>
              Home
            </Button>
          </ButtonGroup>
        </div>

        {isLoading ? (
          <div className="text-center py-5">
            <Spinner animation="border" variant="light" />
          </div>
        ) : (
          <>
            <Row className="g-4">
              {thumbnails.map((thumbnail, index) => (
                <Col key={index} xs={6} sm={4} md={3} lg={2}>
                  <div 
                    className="thumbnail-box"
                    onClick={() => handleThumbnailClick(thumbnail)}
                    style={{
                      cursor: 'pointer',
                      transition: 'transform 0.2s'
                    }}
                  >
                    <img 
                      src={thumbnail.thumbnail_url} 
                      alt={`Thumbnail ${index + 1}`}
                      className="img-fluid rounded"
                      loading="lazy"
                    />
                  </div>
                </Col>
              ))}
            </Row>

            <div className="d-flex justify-content-center gap-3 mt-4 mb-5">
              {currentPage > 0 && (
                <Button
                  variant="primary"
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  ← Previous
                </Button>
              )}
              <Button
                variant="primary"
                onClick={() => handlePageChange(currentPage + 1)}
              >
                Next →
              </Button>
            </div>
          </>
        )}
      </Container>

      <LimitModal show={showLimitModal} setShow={setShowLimitModal}></LimitModal>
    </>
  );
}

export default HentaiView;